import React, { Fragment } from "react";
import Navbar from "../cummon/Navbar";

function ProfileMenu() {
  return (
    <Fragment>
      <Navbar />
      <h1>ini profile</h1>
    </Fragment>
  );
}

export default ProfileMenu;
